var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen"},[(_vm.apiState === _vm.API_STATE_ENUM.PENDING )?[_c('Loader')]:[_c('Dashboard')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }